import { __exports as shouldPolyfill$1 } from "../../../_virtual/should-polyfill.mjs";
Object.defineProperty(shouldPolyfill$1, "__esModule", { value: true });
var shouldPolyfill_2 = shouldPolyfill$1.shouldPolyfill = void 0;
function shouldPolyfill() {
  return typeof Intl === "undefined" || !("DurationFormat" in Intl);
}
shouldPolyfill_2 = shouldPolyfill$1.shouldPolyfill = shouldPolyfill;
export {
  shouldPolyfill$1 as default,
  shouldPolyfill_2 as shouldPolyfill
};
